<script setup lang="ts">
interface ActivityDescriptionTags {
  tagImgUrls: string[];
}

const props = defineProps<ActivityDescriptionTags>();
</script>

<template>
  <div class="activity-description-tags">
    <img
      v-for="url in props.tagImgUrls"
      :key="url"
      class="tag"
      :alt="$t('a11y.activity_tag')"
      :src="url"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-description-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-8);

  .tag {
    width: 115px;
    height: 26px;
  }
}
</style>
